// extracted by mini-css-extract-plugin
export default {"dropdown":"Dropdown_dropdown__pcVex","active":"Dropdown_active__xJ+12","head":"Dropdown_head__zEwrS","body":"Dropdown_body__h4H3j","link":"Dropdown_link__P46Lw"};